class Backdrop {
    fixedClass = 'layout_fixed'
    scrollYProp = '--viewport-scroll-y'

    constructor() {
        this.onDialogShow = this.onDialogShow.bind(this)
        this.onDialogHide = this.onDialogHide.bind(this)
        this.onTransitionEnd = this.onTransitionEnd.bind(this)

        document.addEventListener('dialog:show', this.onDialogShow)
        document.addEventListener('dialog:hide', this.onDialogHide)
    }

    onDialogShow() {
        this.show()
    }

    onDialogHide() {
        this.hide()
    }

    onTransitionEnd(event) {
        if (event.propertyName !== 'visibility' || this.el.classList.contains('visible')) return

        if (document.body.classList.contains(this.fixedClass)) {
            document.body.classList.remove(this.fixedClass)
            document.documentElement.style.removeProperty(this.scrollYProp)
            window.scrollTo({
                top: this.scrollY,
                left: 0,
                behavior: 'instant',
            })
        }
    }

    render() {
        if (this.el) return

        this.el = document.createElement('div')
        this.el.className = 'backdrop'
        document.body.appendChild(this.el)

        this.el.addEventListener('transitionend', this.onTransitionEnd)
        this.el.addEventListener('click', this.onClick)
    }

    show() {
        this.render()

        if (this.el.classList.contains('visible')) return

        if (!document.body.classList.contains(this.fixedClass)) {
            this.scrollY = window.scrollY
            document.documentElement.style.setProperty(this.scrollYProp, `${this.scrollY}px`)
            document.body.classList.add(this.fixedClass)
        }

        this.el.classList.add('visible')
    }

    hide() {
        if (!this.el?.classList.contains('visible')) return

        this.el.classList.remove('visible')
    }
}

export default new Backdrop()
